module.exports = __webpack_public_path__ + "img/list_empty.f2b0b18a.png";